import styled from "styled-components";

export const MobileMenuOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
  z-index: 999;
  opacity: ${(props) => (props.$isOpen ? 1 : 0)};
  visibility: ${(props) => (props.$isOpen ? "visible" : "hidden")};
  transition:
    opacity 0.3s ease,
    visibility 0.3s ease;
`;

export const MobileMenuContainer = styled.div`
  position: fixed;
  top: ${(props) => (props.$tickerVisible ? "104.7px" : "66.7px")};
  right: 0px;
  width: calc(100% - 40px);
  max-width: 350px;
  background: var(--surface);
  border-radius: 20px;
  box-shadow: var(--shadow-medium);
  border: 1px solid var(--accent-light);
  z-index: 1001;
  overflow: hidden;
  transform: ${(props) =>
    props.$isOpen ? "translateX(0) scale(1)" : "translateX(100%) scale(0.95)"};
  opacity: ${(props) => (props.$isOpen ? 1 : 0)};
  visibility: ${(props) => (props.$isOpen ? "visible" : "hidden")};
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transform-origin: top right;
  border-top-right-radius: 0px;
  border-top-left-radius: 0px;
  border-top: none;
`;

export const MobileMenuNav = styled.nav`
  padding: 20px 0;

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
`;

export const MobileNavLink = styled.a`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 15px 25px;
  text-decoration: none;
  color: var(--accent);
  font-weight: ${(props) => (props.$active ? "700" : "500")};
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  background: ${(props) =>
    props.$active ? "var(--secondary)" : "transparent"};
  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 60%;
    width: ${(props) => (props.$active ? "3px" : "0")};
    background: var(--gradient-primary);
    transition: width 0.2s ease;
    border-radius: 0 2px 2px 0;
  }

  &:hover {
    background: var(--accent-light);
    padding-left: 30px;
  }

  svg {
    font-size: 16px;
  }
`;

export const MobileMenuDivider = styled.div`
  height: 1px;
  background: var(--accent-light);
  margin: 15px 20px;
`;

export const MobileMenuActions = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const MobileCartButton = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 12px 20px;
  background: transparent;
  border: 2px solid var(--accent-light);
  border-radius: 25px;
  color: var(--accent);
  font-weight: 600;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: "Source Code Pro", monospace;

  svg {
    font-size: 16px;
  }

  &:hover {
    background: var(--accent);
    color: var(--surface);
    border-color: var(--accent);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const MobileCTAButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 12px 20px;
  background: var(--gradient-primary);
  border: none;
  border-radius: 25px;
  color: var(--surface);
  font-weight: 600;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: var(--shadow-soft);
  font-family: "Source Code Pro", monospace;

  svg {
    font-size: 16px;
  }

  &:hover {
    transform: translateY(-1px);
    box-shadow: var(--shadow-medium);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const CartBadgeMobile = styled.span`
  position: absolute;
  top: -6px;
  right: 12px;
  background: var(--gradient-primary);
  color: var(--surface);
  border-radius: 50%;
  min-width: 20px;
  height: 20px;
  padding: 0 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
  font-family: "Source Code Pro", monospace;
  border: 2px solid var(--surface);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
`;
